import * as React from 'react';
import { Auth } from 'firebase/auth';
import { getFirebaseAuth } from '../utils';

export const useFirebaseAuth = () => {
  const [auth, setAuth] = React.useState<Auth | null>(null);

  React.useEffect(() => {
    const fetchAuth = async () => {
      try {
        const firebaseAuth = await getFirebaseAuth();
        setAuth(firebaseAuth);
      } catch (error) {
        console.error(error);
      }
    };

    if (!auth) fetchAuth();
  }, [auth]);

  return auth;
};
